import styled, { css } from 'styled-components';
import { breakpoints } from 'nicollet-tokens';

const BREAKPOINTS = {
  xs: '0',
  sm: breakpoints.sm,
  md: breakpoints.md,
  lg: breakpoints.lg,
  xl: breakpoints.xl
};

const percentage = value => `${value * 100}%`;

const flexStyles = (columnValue, columnCount = 12) => {
  if (!columnValue) return null;

  if (columnValue === 'auto') {
    return `
      flex: 0 0 auto;
    `;
  }

  if (typeof columnValue === 'boolean') {
    return `
      flex-grow: 1;
      flex-basis: auto;
      max-width: 100%;
    `;
  }

  const value = percentage(columnValue / columnCount);
  return `
    flex-basis: ${value};
    max-width: ${value};
  `;
};

const breakpointFlexStyles = (breakpoint, columnValue, columnCount = 12) => {
  if (!columnValue) return null;
  const offset = `${breakpoint}Offset`;
  return css`
    @media (min-width: ${BREAKPOINTS[`${breakpoint}`]}) {
      margin-left: ${props => props[`${offset}`] ? percentage(props[`${offset}`] / columnCount) : 'initial'};
      ${props => flexStyles(props[`${breakpoint}`])};
    }
  `;
};
const shrinkStyles = (shrink, breakpoint) => {
  if (!shrink) return null;
  const shrinkValue = shrink === true ? 1 : shrink;
  return css`
    @media (min-width: ${BREAKPOINTS[`${breakpoint}`]}) {
      flex-shrink: ${shrinkValue};
    }
  `;
};
const growStyles = (grow, breakpoint) => {
  if (!grow) return null;
  const growValue = grow === true ? 1 : grow;
  return css`
    @media (min-width: ${BREAKPOINTS[`${breakpoint}`]}) {
      flex-grow: ${growValue};
    }
  `;
};
const StyledCol = styled.div`
  box-sizing: border-box;
  flex: 0 0 auto;
  padding-right: 0;
  padding-left: 0;
  border-right-color: inherit;

  ${({
  fill
}) => fill && `
    height: 100%;
    width: 100%;
  `};

  flex-direction: row;

  ${({
  xs
}) => xs && breakpointFlexStyles('xs', xs)};
  ${({
  sm
}) => sm && breakpointFlexStyles('sm', sm)};
  ${({
  md
}) => md && breakpointFlexStyles('md', md)};
  ${({
  lg
}) => lg && breakpointFlexStyles('lg', lg)};
  ${({
  xl
}) => xl && breakpointFlexStyles('xl', xl)};
  ${({
  xsShrink
}) => xsShrink && shrinkStyles(xsShrink, 'xs')};
  ${({
  smShrink
}) => smShrink && shrinkStyles(smShrink, 'sm')};
  ${({
  mdShrink
}) => mdShrink && shrinkStyles(mdShrink, 'md')};
  ${({
  lgShrink
}) => lgShrink && shrinkStyles(lgShrink, 'lg')};
  ${({
  xlShrink
}) => xlShrink && shrinkStyles(xlShrink, 'xl')};
  ${({
  xsGrow
}) => xsGrow && growStyles(xsGrow, 'xs')};
  ${({
  smGrow
}) => smGrow && growStyles(smGrow, 'sm')};
  ${({
  mdGrow
}) => mdGrow && growStyles(mdGrow, 'md')};
  ${({
  lgGrow
}) => lgGrow && growStyles(lgGrow, 'lg')};
  ${({
  xlGrow
}) => xlGrow && growStyles(xlGrow, 'xl')};

  ${({
  xsHiddenUp
}) => xsHiddenUp && `display: none !important;`}

  ${({
  xsHiddenDown
}) => xsHiddenDown && `
    @media (max-width: ${breakpoints.xsMax}) {
      display: none !important;
    }
  `}

  ${({
  smHiddenUp
}) => smHiddenUp && `
    @media (min-width: ${breakpoints.sm}) {
      display: none !important;
    }
  `}

  ${({
  smHiddenDown
}) => smHiddenDown && `
    @media (max-width: ${breakpoints.smMax}) {
      display: none !important;
    }
  `}

  ${({
  mdHiddenUp
}) => mdHiddenUp && `
    @media (min-width: ${breakpoints.md}) {
      display: none !important;
    }
  `}

  ${({
  mdHiddenDown
}) => mdHiddenDown && `
    @media (max-width: ${breakpoints.mdMax}) {
      display: none !important;
    }
  `}

  ${({
  lgHiddenUp
}) => lgHiddenUp && `
    @media (min-width: ${breakpoints.lg}) {
      display: none !important;
    }
  `}

  ${({
  lgHiddenDown
}) => lgHiddenDown && `
    @media (max-width: ${breakpoints.lgMax}) {
      display: none !important;
    }
  `}

  ${({
  xlHiddenUp
}) => xlHiddenUp && `
    @media (min-width: ${breakpoints.xl}) {
      display: none !important;
    }
  `}

  ${({
  xlHiddenDown
}) => xlHiddenDown && `display: none !important;`}
`;

export { StyledCol, breakpointFlexStyles, growStyles, shrinkStyles };
